import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import OvTimeInfoCard from "./OvTimeInfoCard";
import OvTimeCostChart from "./OvTimeCostChart";
import OvTimeMinutesChart from "./OvTimeMinutesChart";
import OvTimeStorageChart from "./OvTimeStorageChart";
import OvTimeCoresChart from "./OvTimeCoresChart";
import { withRouter } from "react-router-dom";
import UIFocusSwitchContainer from "./UIFocusSwitchContainer";

const styles = (theme) => ({
  root: {
    padding: 20,
  },
});

const OvTimeView = (props) => {

  const { classes } = props;
  return (
    <div className={classes.root}>
      <OvTimeInfoCard {...props} />

      <OvTimeCostChart {...props} />
      <OvTimeCoresChart {...props} />
      <OvTimeMinutesChart {...props} />
      <OvTimeStorageChart {...props} />
      <UIFocusSwitchContainer />
    </div>
  );
};

OvTimeView.propTypes = {
  data: PropTypes.array.isRequired,
  granularity: PropTypes.object.isRequired,
  filterState: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export { OvTimeView };

export default withStyles(styles, { name: "OvTimeView" })(
  withRouter(OvTimeView)
);



// WEBPACK FOOTER //
// ./src/OvTimeView.js